import React from "react";
import { Link } from "react-router-dom";
import "./payment-plans.css";
import paidStamp from "images/paid-stamp.png";
import arrowIcon from "images/arrow-icon.png";
import { currencyFormat, dateFormat } from "shared/components/helpers";

const PLANS = ['active', 'paid', 'cancelled'];

function PaymentPlans(props) {
  let newPaymentClick = (plan, paymentMethods) => {
    props.handleShow("Payment", true, {
      currentPlan: plan,
      paymentMethods
    });
  };

  let accountHistoryClick = plan => {
    props.handleShow("AccountHistory", true, {
      currentPlan: plan
    });
  };

  let viewDocumentsClick = plan => {
    props.handleShow("PaymentDocuments", true, {
      currentPlan: plan
    });
  };

  let newPaymentLink =
    props.plan.status === "active" ? (
      <Link
        className="btn btn-warning"
        disabled={!props.paymentMethods.length}
        to={"/plans/" + props.plan.paymentId + "/payments/new"}
        onClick={() => newPaymentClick(props.plan, props.paymentMethods)}
      >
        Make a payment
      </Link>
    ) : null;

  let viewDocumentsLink =
    props.plan.paymentType === "full" ? null : (
      <Link to="#" onClick={() => viewDocumentsClick(props.plan)}>
        View my documents
      </Link>
    );

  const verificationLink = (
    <Link
      className="payment-plan-verification"
      to="#"
      onClick={(evt) => {
      evt.preventDefault();
      props.showVerificationDialog(props.unverifiedACH)
    }}
    >
      <span>
        <span className="glyphicon glyphicon-exclamation-sign"/>&nbsp;
        Bank Verification Needed
      </span>

    </Link>
  );

  return (
    <div
      className={"payment-plans " + (props.showDetails ? "with-details" : "")}
    >
      <div className="row">
        <div className="col-md-3">
          Provider name: {props.plan.provider} <br />
          Original balance: {currencyFormat(props.plan.originalBalance)} <br />
          Down payment: {currencyFormat(props.plan.initialDownPayment)} <br />
          Start date: {dateFormat(props.plan.paymentStartDate)} <br />
          Payment Type:
          {(props.plan.paymentType) === "full"
            ? (" Full Payment")
            : ((props.plan.paymentType) === "weekly_plan"
                  ? (" Weekly Payment Plan")
                  : (" Monthly Payment Plan"))} <br />
          {!!props.unverifiedACH.length && verificationLink}
        </div>

        <div className="col-md-2">
          {props.plan.status === "paid" ? (
            <img src={paidStamp} alt="Paid" className="paid-stamp" />
          ) : null}
        </div>

        <div className="col-md-3">
          Remaining balance: {currencyFormat(props.plan.totalDueAmount)}
          <br />
          Past due amount: {currencyFormat(props.plan.pastDueAmount)}
          <br />
          {PLANS.includes(props.plan.status) ? (
            <div>
              <Link to="#" onClick={() => accountHistoryClick(props.plan)}>
                View Account History
              </Link>
              <br />
            </div>
          ) : null}
          {viewDocumentsLink}
        </div>

        <div className="col-md-3">
          Payment amount: {currencyFormat(props.plan.monthlyAmountDue)}
          <br />
          Next payment date: {dateFormat(props.plan.nextPaymentDate)}
          <br /> <br />
          {newPaymentLink}
        </div>

        <div className="col-md-1">
          {props.plan.status === "active" ? (
            <a
              onClick={() => props.handleClickArrow(props.plan.paymentId)}
            >
              <img
                src={arrowIcon}
                alt="arrow"
                className={"arrow " + (props.showDetails ? "rotate" : null)}
              />
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
export default PaymentPlans;

PaymentPlans.defaultProps = {
  unverifiedACH: []
}



// WEBPACK FOOTER //
// ./src/home/components/payment-plans.js